import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

const GuestPlayerDialog = ({ dialogOpen, setDialogOpen, addGuestPlayer, players }) => {
    const [error, setError] = useState();
    const [name, setName] = useState('');

    const setGuestName = () => {
        if (name.length <= 0) {
            setError('Ange namn');
        } else if (players.filter(p => p.name === name).length > 0) {
            setError('Spelaren finns redan');
        } else {
            addGuestPlayer(name);
            setName('');
            setError('');
        }
    }

    return (
        <div>
            <Dialog open={dialogOpen}>
                <DialogTitle>Lägg till gäst</DialogTitle>
                <DialogContent>
                    <div className='mt-4'>
                        <div className='mb-2'>
                            <TextField sx={{ width: '100%' }} id="cpd-old-password" label="Namn" variant="outlined" type="text" value={name} autoFocus
                                onChange={e => setName(e.target.value)}
                                onKeyUp={e => {
                                    if (e.keyCode === 13) {
                                        setGuestName();
                                    }
                                }}
                            />
                        </div>
                        {error && <span className='error'>{error}</span>}
                    </div>
                </DialogContent>
                <DialogActions>
                    <div className='s4g-dialog-control'>
                        <Button className='m-3' variant="outlined" onClick={() => setDialogOpen(false)}>Avbryt</Button>
                        <Button className='m-3' variant="contained" onClick={() => {
                            setGuestName();
                        }}>Lägg till</Button>
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default GuestPlayerDialog;